import axios from 'axios';
import { baseurl } from '../config/url';

const axiosInstance = axios.create({
    baseURL: `${baseurl}/api`,
});

axiosInstance.interceptors.response.use(null, async (error) => {
    if (error.response && error.response.status === 429) {
        const retryAfter = error.response.headers['retry-after'];
        if (retryAfter) {
            await new Promise(resolve => setTimeout(resolve, retryAfter * 1000));
            return axiosInstance(error.config);
        }
    }
    return Promise.reject(error);
});

export default axiosInstance;
